export default {
  video: {
    home: {
      mp4: "/recherche-81077d8f369bb81a9e0db3fd4eff9888.mp4",
      ogg: "/recherche-a720edd4bca7529a3e93fa003c50e937.ogg",
      webm: "/recherche-4cf813bcd86db7c23ae2236e33cba5a6.webm",
    },
    travel: "/header-0869f9fc3193e488a69029b45cf57b22.mp4",
  },

  image: {
    deviceLinks: {
      tvImage: "/_1536328906_DeviceLinks-tv.svg",
      desktopImage: "/_1536328906_DeviceLinks-desktop.svg",
      tabletImage: "/_1536328906_DeviceLinks-tablet.svg",
      phoneImage: "/_1536328906_DeviceLinks-phone.svg",
    },

    googleAssistant: {
      headerImage: "/_1592486866_illus_Nest_Hub.png",
      headerImage2x: "/_1592486914_illus_Nest_Hub2x.png",
      nesthubImage: "/_1593545986_illus_Nest_Hub_2.png",
      nesthubImage2x: "/_1593545979_illus_Nest_Hub_2x2.png",
      startOverImage: "/_1593546041_illus_Nest_Hub_start_over.png",
      startOverImage2x: "/_1593546007_illus_Nest_Hub_start_overx2.png",
    },

    liveLabel: {
      liveLabelBigImage: "/_1536329150_LiveLabel-big.gif",
      liveLabelSmallImage: "/_1536329150_LiveLabel-small.gif",
    },

    pageAmazonAlexa: {
      headerImage: "/_1593551067_illus_Echo_Show_3.png",
      headerImage2x: "/_1593551071_illus_Echo_Show_3x2.png",
      echoShowImage: "/_1592485365_illus_Echo_Show.png",
      echoShowImage2x: "/_1592485476_illus_Echo_Show2x.png",
      startOverImage: "/_1593551056_illus_Echo_Show_Start_Over.png",
      startOverImage2x: "/_1593551064_illus_Echo_Show_Start_Overx2.png",
    },

    pageErrors: {
      notFound: "/_1536235401_PageError-not-found-tv.png",
    },

    pageDeeplinkGeneric: {
      molotovLogo: "/_1536236728_PageDeeplinkGeneric-app-icon-molotov.svg",
    },

    pageAbout: {
      jeanDavidBlancImage: "/_1536240297_PageAbout-jeandavid_blanc.png",
      pierreLescureImage: "/_1536240300_PageAbout-pierre_lescure.png",
      jeanMarcDenoualImage: "/_1536240295_PageAbout-jean-marc_denoual.png",
    },

    pageAndroid: {
      headerImage: "/_1620740854_page_android_header.webp",
      headerImage2x: "/_1620740852_page_android_header_x2.webp",
      chromecastImage: "/_1620740849_page_android_chromecast.webp",
      chromecastImage2x: "/_1620740846_page_android_chromecast_x2.webp",
      loginImage: "/_1620740859_page_android_Play_store.webp",
      loginImage2x: "/_1620740857_page_android_Play_store_x2.webp",
      tabletImage: "/_1620740865_page_android_tablet.webp",
      tabletImage2x: "/_1620740862_page_android_tablet_x2.webp",
    },

    pageHuawei: {
      headerImage: "/_1607954877_494x294-Huawei.png",
      headerImage2x: "/_1607696664_494x294-Huawei@x2.png",
      huaweiLive: "/_1594755026_illus_Huawei_live.png",
      huaweiLive2x: "/_1594755026_illus_Huawei_live.png",
      huaweiImage: "/_1594755032_illus_Huawei_image.png",
      huaweiImage2x: "/_1594755032_illus_Huawei_image.png",
      huaweiStoreImage: "/_1594755037_illus_Huawei_store.png",
      huaweiStoreImage2x: "/_1594755037_illus_Huawei_store.png",
    },

    pageAppleTv: {
      headerImage: "/_1620741044_page_Apple_TV_header.webp",
      headerImage2x: "/_1620741042_page_Apple_TV_header_x2.webp",
      programsImage: "/_1620741039_page_Apple_TV_enregistrement.webp",
      programsImage2x: "/_1620741037_page_Apple_TV_enregistrement_x2.webp",
      installImage: "/_1620741049_page_Apple_TV_home.webp",
      installImage2x: "/_1620741046_page_Apple_TV_home_x2.webp",
    },

    pageCampaign: {
      cdiscountImage: "/_1536242469_PageCompaign-cdiscount1x.png",
      cdiscountImage2x: "/_1536242469_PageCompaign-cdiscount2x.png",
    },

    pageChromecast: {
      headerImage: "/_1620741215_page_Chromecast_header.webp",
      headerImage2x: "/_1620741213_page_Chromecast_header_x2.webp",
      channelsImage: "/_1620741224_page_Chromecast_remote.webp",
      channelImage2x: "/_1620741222_page_Chromecast_remote_x2.webp",
      chromecastImage: "/_1620741202_page_Chromecast_appareil.webp",
      chromecastImage2x: "/_1620741200_page_Chromecast_appareil_x2.webp",
      illusChromecastImage: "/_1620741219_page_Chromecast_icone.webp",
      illusChromecastImage2x: "/_1620741217_page_Chromecast_icone_x2.webp",
      chromecastAppImage: "/_1620741206_page_Chromecast_cast.webp",
      chromecastAppImage2x: "/_1620741204_page_Chromecast_cast_x2.webp",
    },

    pageDesktop: {
      headerImage: "/_1620741483_page_desktop_header.webp",
      headerImage2x: "/_1620741481_page_desktop_header_x2.webp",
      programsImage: "/_1620741478_page_desktop_enregistrement.webp",
      programsImage2x: "/_1620741476_page_desktop_enregistrement_x2.webp",
      channelsImage: "/_1620741474_page_desktop_chaines.webp",
      channelsImage2x: "/_1620741471_page_desktop_chaines_x2.webp",
      desktopImage: "/_1620741496_page_desktop_start_over.webp",
      desktopImage2x: "/_1620741485_page_desktop_start_over_x2.webp",
    },

    pageDirect: {
      headerImage: "/_1536245491_PageDirect-header.png",
      directImage: "/_1556287527_PageDirect-direct.png",
      directImage2x: "/_1556287524_PageDirect-direct2x.png",
    },

    pageDownloading: {
      windowsDownloadImage: "/_1536245990_PageDownloading-windows-download.png",
      windowsInstallImage: "/_1536245990_PageDownloading-windows-install.png",
      macInstallImage: "/_1536246080_PageDownloading-mac-install.png",
      macChromeDownloadImage: "/_1536246080_PageDownloading-mac-chrome.png",
      macSafariDownloadImage: "/_1536246080_PageDownloading-mac-safari.png",
      linuxDownloadImage: "/_1744984406_PageDownloading-linux-download.png",
      linuxInstallImage: "/_1745327129_PageDownloading-linux-install.png",
      connectImage: "/_1536246195_PageDownloading-connect.png",
      watchImage: "/_1707226899_PgaDowloading-watch (2).png",
    },

    pageFreeChannels: {
      headerImage: "/_1556287884_PageFreeChannels-header.png",
      headerImage2x: "/_1556287889_PageFreeChannels-header2x.png",
      devicesImage: "/_1556287672_PageFreeChannels-devices.png",
      devicesImage2x: "/_1556287672_PageFreeChannels-devices2x.png",
    },

    pageHardware: {
      appStoreImage: "/_1536247531_PageHardware-link_appstore.png",
      huaweiStoreImage: "/_1595497356_huawei_store_image.png",
      illusAndroidImage: "/_1707226664_Tablet mobile Android 494x294 @x4 (1).png",
      illusAndroidImage2x: "/_1707227439_Tablet mobile Android 494x294 @x4 (4).png",
      illusAppleTVImage: "/_1556033581_PageHardware-illus_appletv.png",
      illusAppleTVImage2x: "/_1556029746_PageHardware-illus_appletv2x.png",
      illusBrowserImage: "/_1628174545_PageHardware-illus_browser_2x.webp",
      illusBrowserImage2x: "/_1628174545_PageHardware-illus_browser_2x.webp",
      illusChromeCastImage: "/_1607356361_hardwareChromecast.png",
      illusChromeCastImage2x: "/_1607356361_hardwareChromecast@2.png",
      illusDesktopImage: "/_1556184502_PageHardware-illus_desktop.png",
      illusDesktopImage2x: "/_1556029663_PageHardware-illus_desktop2x.png",
      illusEchoShow: "/_1592485365_illus_Echo_Show.png",
      illusEchoShow2x: "/_1592485476_illus_Echo_Show2x.png",
      illusFireStick: "/_1620741779_page_device_fire_stick.webp",
      illusFireStick2x: "/_1620741776_page_device_fire_stick_x2.webp",
      illusGoogleChromecast: "/_1550850191_PageHardware-google_chromecast_molotov.jpg",
      illusHisense: "/_1620741877_page_device_Hisense.webp",
      illusHisense2x: "/_1620741875_page_device_Hisense_x2.webp",
      illusHuawei: "/_1607954877_494x294-Huawei.png",
      illusHuawei2x: "/_1607696664_494x294-Huawei@x2.png",
      illusNestHub: "/_1592486866_illus_Nest_Hub.png",
      illusNestHub2x: "/_1592486914_illus_Nest_Hub2x.png",
      illusIphoneImage: "/_1556028610_PageHardware-illus_ios.png",
      illusIphoneImage2x: "/_1556636841_PageHardware-illus_ios2x.png",
      illusLGImage: "/_1556640784_PageHardware-illus_lg.png",
      illusLGImage2x: "/_1556640794_PageHardware-illus_lg2x.png",
      illusNvidiaShield: "/_1620741953_page_device_NVIDIA_Shield.webp",
      illusNvidiaShield2x: "/_1620741950_page_device_NVIDIA_Shield_x2.webp",
      illusOculus: "/_1550851491_PageHardware-oculus.png",
      illusPanasonicImage: "/_1556636649_PanasonicTV.png",
      illusPanasonicImage2x: "/_1556636649_PanasonicTV@2x.png",
      illusSamsungImage: "/_1556640375_PageHardware-illus_samsung.png",
      illusSamsungImage2x: "/_1556640398_PageHardware-illus_samsung2x.png",
      illusSonyImage: "/_1620742010_page_device_sony.webp",
      illusSonyImage2x: "/_1620742007_page_device_sony_x2.webp",
      illusSourcePanasonicImage: "/_1602443145_illus_source_Panasonic.png",
      illusSourcePanasonicImage2x: "/_1602443149_illus_source_Panasonic_x2.png",
      illusTCLImage: "/_1620742061_page_device_THOMSON.webp",
      illusTCLImage2x: "/_1620742059_page_device_THOMSON_x2.webp",
      illusXiaomi: "/_1598211219_illus_Xiaomi_header.png",
      illusXiaomi2x: "/_1598211223_illus_Xiaomi_header2x.png",
      logoNestHub: "/_1592486827_logo_Nest_Hub.png",
      logoAndroid: "/_1536247532_PageHardware-logo_android.svg",
      logoAmazonFireStick: "/_1536247532_PageHardware-logo_amazon_firestick.png",
      logoApple: "/_1536247532_PageHardware-logo_apple.svg",
      logoAppleTv: "/_1536247533_PageHardware-logo_appletv.svg",
      logoChromeCast: "/_1536247533_PageHardware-logo_chromecast.png",
      logoHuawei: "/_1594753744_logo_Huawei.png",
      logoLG: "/_1536247533_PageHardware-logo_lg.png",
      logoLinux: "/_1536247533_PageHardware-logo_linux.png",
      logoEchoShow: "/_1592485137_logo_Echo_Show.png",
      logoNvidiaShield: "/_1536247533_PageHardware-logo_nvidiashield.png",
      logoOculus: "/_1550851432_PageHardware-oculus-logo.png",
      logoPanasonic: "/_1541153374_PanasonicLogoGrey.png",
      logoSamsung: "/_1536247534_PageHardware-logo_samsung.png",
      logoSony: "/_1536247534_PageHardware-logo_sony.png",
      logoThomson: "/_1536247534_PageHardware-logo_thomson.png",
      logoWindows: "/_1536247534_PageHardware-logo_windows.svg",
      logoXiaomi: "/_1598209121_logo_XIAOMi_Stick_TV.png",
      illusXbox: "/_1592474239_illus_Xbox_one.png",
      illusXbox2x: "/_1592487358_illus_Xbox_one2x.png",
      logoXbox: "/_1592473356_logo_Xbox.png",
      logoHisense: "/_1604674503_Hisense-Logo.png",
      playStoreImage: "/_1536247532_PageHardware-link_playstore.png",
    },

    pageHome: {
      testiTCImage: "/_1536249122_PageHome-testi_TC.png",
      testiForbesImage: "/_1536249161_PageHome-testi_forbes.png",
      testiFTImage: "/_1536249161_PageHome-testi_FT.png",
      logoTeleramaImage: "/_1536249159_PageHome-logo_telerama.png",
      logoFigaroImage: "/_1536249158_PageHome-logo_figaro.png",
      logoAppleImage: "/_1536249157_PageHome-logo_apple.svg",
      logoInrocksImage: "/_1536249158_PageHome-logo_inrocks.svg",
      logo01netImage: "/_1536249157_PageHome-logo_01net.png",
      logoCapitalImage: "/_1536249158_PageHome-logo_capital.png",
      thumbnailErrorImage: "/_1536249161_PageHome-thumbnail_error.jpg",
      logoImage: "/_1676651708_molotov_by_fubo_hardblack2.png",
      ogImage: "/_1620222252_molotov-logo.png",
      logoMolotovPlus: "/_1638195333_Topbar-Molotov_Plus.png",
    },

    pageIphone: {
      headerImage: "/_1620742126_page_iphone_header.webp",
      headerImage2x: "/_1620742123_page_iphone_header_x2.webp",
      directImage: "/_1620742130_page_iphone_IOS_live.webp",
      directImage2x: "/_1620742128_page_iphone_IOS_live_x2.webp",
      replayImage: "/_1620742121_page_iphone_enregistrement.webp",
      replayImage2x: "/_1620742118_page_iphone_enregistrement_x2.webp",
      iphoneImage: "/_1620742116_page_iphone_Appstore.webp",
      iphoneImage2x: "/_1620742114_page_iphone_Appstore_x2.webp",
    },

    pageLG: {
      headerImage: "/_1620742306_page_LG_perso.webp",
      headerImage2x: "/_1620742304_page_LG_perso_x2.webp",
      broadcastImage: "/_1620742310_page_LG_start_over.webp",
      broadcastImage2x: "/_1620742308_page_LG_start_over_x2.webp",
      menuImage: "/_1620742297_page_LG_categories.webp",
      menuImage2x: "/_1620742295_page_LG_categories_x2.webp",
      programsImage: "/_1620742301_page_LG_enregistrement.webp",
      programsImage2x: "/_1620742299_page_LG_enregistrement_x2.webp",
      installImage: "/_1620742293_page_LG_app.webp",
      installImage2x: "/_1620742290_page_LG_app_x2.webp",
    },

    pageOAuth: {
      iconMolotovImage: "/_1536236916_PageOAuth-app-icon-molotov.svg",
    },

    pageOnMyTv: {
      deviceImage: {
        TVHisense: "/_1604662495_OnMyTv-samsung.png",
        TVSamsung: "/_1588583857_PageOnMyTv-samsung.png",
        TVLG: "/_1588584008_PageOnMyTv-lg.png",
        TVSony: "/_1588584065_PageOnMyTv-sony.png",
        TVPhilips: "/_1588860956_PageOnMyTv-philips.png",
        TVAndroid: "/_1588584183_PageOnMyTv-androidtv.png",
        TVTCL: "/_1588584342_PageOnMyTv-tcl.png",
        TVPanasonic: "/_1588584410_PageOnMyTv-panasonictv.png",
        EchoShow: "/_1607349356_illus_echo_show_4x.png",
        GoogleNestHub: "/_1593589707_illus_Nest_Hubx4.png",
        chromecast: "/_1609767194_110x110Chromecastdevice.png",
        appletv: "/_1588584785_PageOnMyTv-appletv.png",
        amazonfirestick: "/_1588584885_PageOnMyTv-amazonfirestick.png",
        xiaomi: "/_1588585006_PageOnMyTv-xiaomi.png",
        nvidiashield: "/_1588585075_PageOnMyTv-nvidiashield.png",
        freebox4k: "/_1588585228_PageOnMyTv-freebox4k.png",
        bboxmiami: "/_1588585297_PageOnMyTv-bboxmiami.png",
        Xbox: "/_1594805492_illus_Xbox_onex4.png",
        XiaomiStick: "/_1600344141_PageOnMyTv_MiTVStick.png",
        watchTVPanasonic: "/_1606743749_PanasonicOnMyTv.png",
      },
    },

    pagePanasonic: {
      headerImage: "/_1620742723_page_Panasonic_header.webp",
      headerImage2x: "/_1620742722_page_Panasonic_header_x2.webp",
      tvImage: "/_1620742727_page_Panasonic_prog.webp",
      tvImage2x: "/_1620742726_page_Panasonic_prog_x2.webp",
      installImage: "/_1620742720_page_Panasonic_app.webp",
      installImage2x: "/_1620742718_page_Panasonic_app_x2.webp",
    },

    pageXbox: {
      headerImage: "/_1592474239_illus_Xbox_one.png",
      headerImage2x: "/_1592487358_illus_Xbox_one2x.png",
      xboxImage: "/_1593613471_illus_Xbox_one_2.png",
      xboxImage2x: "/_1593613466_illus_Xbox_one_2x2.png",
      xboxStartOverImage: "/_1593613477_illus_Xbox_one_Start_Over.png",
      xboxStartOverImage2x: "/_1593613474_illus_Xbox_one_Start_Overx2.png",
    },

    pagePayment: {
      lock: "/_1541666393_molotovpay_lock.svg",
      americanExpress: "/_1541666383_molotovpay_american_express.svg",
      visa: "/_1541666400_molotovpay_visa.svg",
      mastercard: "/_1541666397_molotovpay_mastercard.svg",
      cvv: "/_1541666389_molotovpay_cvv.svg",
      exclamationmark: "/_1542029206_exclamationmark.svg",
      chevronDown: "/_1645043610_chevron-down.png",
      chevronUp: "/_1645043610_chevron-up.png",
      check: "/_1645050361_payment_check_shape.png",
      paypal: "/_1716814562_Paypal_2014_logo.png",
    },

    pageReplay: {
      headerImage: "/_1536310043_PageReplay-header.png",
      programsImage: "/_1536310043_PageReplay-programs.png",
      programsImage2x: "/_1536310044_PageReplay-programs@2x.png",
    },

    pageSamsung: {
      headerImage: "/_1620742888_page_Samsung_header.webp",
      headerImage2x: "/_1620742885_page_Samsung_header_x2.webp",
      tvImage: "/_1620742882_page_Samsung_categorie.webp",
      tvImage2x: "/_1620742880_page_Samsung_categorie_x2.webp",
      installImage: "/_1620742876_page_Samsung_app.webp",
      installImage2x: "/_1620742874_page_Samsung_app_x2.webp",
    },

    pageStreaming: {
      headerImage: "/_1536311123_PageStreaming-header.png",
      streamingImage: "/_1556288081_PageStreaming-streaming.png",
      streamingImage2x: "/_1556288078_PageStreaming-streaming2x.png",
    },

    pageHisense: {
      headerImage: "/_1604501898_HisenseOnMyTV.png",
      headerImage_2x: "/_1608215253_HisenseOnMyTV_2x.png",
      tvImage: "/_1604572077_Hisense-01.png",
      tvImage_2x: "/_1604572089_Hisense-01@x2.png",
      tvImage2: "/_1604572335_Hisense-02.png",
      tvImage2_2x: "/_1604572338_Hisense-02@x2.png",
      tvImage3: "/_1604572396_Hisense-03.png",
      tvImage3_2x: "/_1604572401_Hisense-03@x2.png",
      tvImage4: "/_1604572483_Hisense-04.png",
      tvImage4_2x: "/_1604572486_Hisense-04@x2.png",
      tvImage5: "/_1604579945_Hisense-05.png",
      tvImage5_2x: "/_1604579949_Hisense-05@x2.png",
    },

    tileVideo: {
      tileVideoImage: "/_1536322491_TileVideo-img_more.jpg",
    },

    pageMolotovPlus: {
      slider: "/_1541514029_carrousel_PLUS.png",
      slider2x: "/_1541514033_carrousel_PLUS@2x.png",
      tv: "/_1541001750_PageMolotovPlus_tv.png",
      tv2x: "/_1541001755_PageMolotovPlus_tv@2x.png",
    },

    Footer: {
      downloadIcons: "/_1554891278_FooterDownloadIcons.png",
      downloadIconsDark: "/_1572345513_FooterDownloadIcons-Dark.png",
    },

    pageGifts: {
      checkmarkImage: "/_1536311699_PageTravel-checkmark.svg",
      gift: "/_1542378324_gift.svg",
      wave: {
        cine: "/_1542367834_vagues_CINE@2x.png",
        extended: "/_1542367837_vagues_EXTENDED@2x.png",
        plus: "/_1542367846_vagues_PLUS@2x.png",
      },
    },

    pageXiaomi: {
      headerImage: "/_1598211219_illus_Xiaomi_header.png",
      headerImage2x: "/_1598211223_illus_Xiaomi_header2x.png",
      xiaomiImage: "/_1598211226_illus_Xiaomi_tv.png",
      xiaomiImage2x: "/_1598211228_illus_Xiaomi_tv2x.png",
      xiaomiTvImage: "/_1598211231_illus_Xiaomi_image.png",
      xiaomiTvImage2x: "/_1598211234_illus_Xiaomi_image2x.png",
    },

    pageSubscribe: {
      molotovByFuboLogo: "/_1676651708_molotov_by_fubo_hardblack1.png",
    },

    dsp: {
      ibloo: {
        logo: "/_1564479236_logo-ibloo.png",
        logox2: "/_1564479237_logo-ibloo@2x.png",
        logoProduct: "/_1580119985_ibloo-logo-sub.png",
        sliderImages: [
          {
            url: "/_1567435958_ibloo-slider-image-1.png",
            urlx2: "/_1567435983_ibloo-slider-image-1@2x.png",
          },
          {
            url: "/_1567436019_ibloo-slider_image2.png",
            urlx2: "/_1567436019_ibloo-slider_image2@2x.png",
          },
          {
            url: "/_1567436072_ibloo-slider_image3.png",
            urlx2: "/_1567436020_ibloo-slider_image3@2x.png",
          },
        ],
      },
    },

    molotovMultiDevices: {
      banner: {
        jp2: "/_1622539909_Home_4_ecrans_header.jp2",
        webp: "/_1622539909_Home_4_ecrans_header.webp",
      },

      banner2x: {
        jp2: "/_1622538657_Home_4_ecrans_header@x2.jp2",
        webp: "/_1622538653_Home_4_ecrans_header@x2.webp",
      },
    },
  },

  doc: {
    legal: {
      reglement_molotov_on_instagram: "/_1614069551_reglement_jeu_molotov_on_instagram.pdf",
      reglement_molotov_x_manon: "/_1615199436_Reglement_jeu_Manon_X_Molotov_202103.pdf",
      reglement_molotov_x_hoversmash: "/_1615565430_reglement-jeu-hoversmash-x-molotov.pdf",
      reglement_molotov_x_julien_chieze: "/_1616162547_reglement_jeu_Julien_Chieze_X_Molotov.pdf",
      reglement_molotov_x_kev: "/_1616760450_Reglement_jeu_CAMKEV_X_Molotov.pdf",
      reglement_got_10_ans_insta: "/_1617955597_REGLEMENT_DE_JEU_GOT_10_ans_Version_Instagram_Molotov_avril_2021.pdf",
      reglement_tu_as_la_ref: "/_1620393271_reglement_de_jeu_tu_as_la_ref_Version_Instagram_Molotov_mai_2021.pdf",
      reglement_tom_et_jerry: "/_1621412109_Tom_Jerry_X_Molotov_mai_2021.pdf",
    },
  },
}
